import React from 'react';
import cls from 'classnames';

import { YoutubePlayer } from '../YoutubePlayer';

export interface IYoutubePlayerContainer {
  title?: string;
  description?: string;
  background?: 'white' | 'kiwi' | 'cloud' | 'lemon' | 'grape' | 'pomelo';
  videoId: string;
}
export const YoutubePlayerContainer: React.FC<IYoutubePlayerContainer> = (props) => {
  const { title, description, background, videoId } = props;
  return (
    <section
      className={cls('border-b border-cloud-900', {
        'bg-white': background === 'white',
        'bg-kiwi-400': background === 'kiwi',
        'bg-cloud-800': background === 'cloud',
        'bg-lemon-400': background === 'lemon',
        'bg-grape-500': background === 'grape',
        'bg-pomelo-400': background === 'pomelo',
        'text-cloud-900': background !== 'cloud',
        'text-onion-50': background === 'cloud',
      })}
    >
      <div className="app-container mx-auto w-full px-16 xs-only:px-2 py-8">
        <h4 className="text-display-md mb-4">{title}</h4>
        {description && <div dangerouslySetInnerHTML={{ __html: description }}></div>}
        <YoutubePlayer videoId={videoId} />
      </div>
    </section>
  );
};
